import { StateCreator } from "zustand";
export type TAgentPerformanceFilterSelection = {
  id: string;
  name: string;
};

export type TAgentPerformanceFilters = {
  campaign_id?: string;
  template_id?: string;
  call_date_start?: string;
  call_date_end?: string;
  is_active?: boolean | string;
  sort?: string;
  date_type?: string;
  period?: string;
  hierarchyScope?: string;
  dateType?: string;
  startDate?: string;
  endDate?: string;
  campaign?: TAgentPerformanceFilterSelection;
  template?: TAgentPerformanceFilterSelection;
  service?: TAgentPerformanceFilterSelection;
  agent?: TAgentPerformanceFilterSelection;
  searchType?: string;
  searchQuery?: string;
  periodValue?: string;
  supervisor?: TAgentPerformanceFilterSelection;
  rankBasedAuditorId?: string;
  csat?: string;
  fcr?: string;
  profanity?: string;
  aiScoreMin?: string;
  aiScoreMax?: string;
  qaScoreMin?: string;
  qaScoreMax?: string;
  group_by?: string;
  achievement?: string;
};

export type TAgentPerformanceStore = {
  agentPerformanceFilters: TAgentPerformanceFilters;
  setAgentPerformanceFilters: (
    filters:
      | TAgentPerformanceFilters
      | ((prev: TAgentPerformanceFilters) => TAgentPerformanceFilters),
  ) => void;
};

export const createAgentPerformanceSlice: StateCreator<
  TAgentPerformanceStore,
  [],
  [],
  TAgentPerformanceStore
> = (set) => ({
  agentPerformanceFilters: {
    campaign_id: "",
    template_id: "",
    is_active: "active",
    sort: "-total_compliance",
    period: "last-week",
    date_type: "call_date",
    hierarchyScope: "",
    dateType: "call_date",
    startDate: "",
    endDate: "",
    campaign: { id: "", name: "" },
    service: { id: "", name: "" },
    agent: { id: "", name: "" },
    template: { id: "", name: "" },
    searchType: "ai_score",
    searchQuery: "",
    periodValue: "last-week",
    supervisor: { id: "", name: "" },
    rankBasedAuditorId: "",
    csat: "",
    fcr: "",
    profanity: "",
    aiScoreMin: "",
    aiScoreMax: "",
    qaScoreMin: "",
    qaScoreMax: "",
    achievement: "",
    group_by: "",
  },
  setAgentPerformanceFilters: (filters) =>
    set((state) => ({
      agentPerformanceFilters:
        typeof filters === "function"
          ? filters(state.agentPerformanceFilters)
          : filters,
    })),
});
